import { QueryClient } from '@tanstack/react-query';
import { toastQueryError } from '@/lib/errorToast';

// In test mode, disable query caching to prevent background GC timers from keeping Node alive
const isTestEnv = typeof import.meta !== 'undefined' && !!(import.meta as any)?.env && (import.meta as any).env.MODE === 'test';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Coherent defaults for production
      staleTime: isTestEnv ? 0 : 30_000, // 30s
      cacheTime: isTestEnv ? 0 : 5 * 60 * 1000, // 5min GC
      // Avoid retries in tests to reduce background async work
      retry: isTestEnv ? false : 1,
      refetchOnWindowFocus: false,
      // Global error toast
      onError: (error: unknown) => {
        toastQueryError(error, { operation: 'query' });
      },
    },
    mutations: {
      retry: false,
      onError: (error: unknown, _variables: unknown, _context: unknown) => {
        toastQueryError(error, { operation: 'mutation' });
      },
    },
  },
});
